export const variables = {
  shareUrl: 'share',
  businessUrl: 'business-id',
  inviteCode: 'invite',
  languageCodeStorageKey: 'LOCALIZE_DEFAULT_LANGUAGE',
  defaultLanguage: 'en',
  websocketAipUrlKey: 'WEBSOCKET_API_URL',
  businessEntityIdParam: 'business-entity-id',
  defaultRedirectPage: 'ads',
  auth: 'auth',
};
